import styled from 'styled-components';
import { resetBtn } from 'styled-manila';
import { typeScale } from 'core/utils';

import Button from 'core/ui/Button';
import { desktop } from 'core/components/Form/formStyles';
import { getColor } from 'core/utils/Styles';

export const Wrapper = styled.div`
	margin: 50px auto;
	width: 92vw;
	background-color: ${getColor('white')};
	border-radius: 4px;
	position: relative;
	max-width: 650px;
`;

export const BodyText = styled.div`
	font-size: 16px;
	letter-spacing: 0.2px;
	color: ${getColor('dustyGray')};
	padding: ${typeScale(2)} ${typeScale(2)} ${typeScale(3)};

	${desktop`
		padding: ${typeScale(2)} ${typeScale(3)} ${typeScale(3)};
	`}
`;

export const Footer = styled.div`
	padding: ${typeScale(2)} ${typeScale(2)} ${typeScale(3)};

	${desktop`
		display: flex;
		flex-direction: row;
		padding: ${typeScale(2)} ${typeScale(3)} ${typeScale(3)};
	`}
`;

export const ShareZoneHeading = styled.div`
	color: ${getColor("gray")};
	font-size: 14px;
	font-weight: 600;
	line-height: 1.05;
	letter-spacing: 0.2px;
	margin: 0 0 ${typeScale(1)} ${typeScale(1)};
`;

export const ShareZoneWrapper = styled.div`
	flex: 1;
`;

export const ShareButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const ViewWishlistBtn = styled(Button)`
	padding: 0 24px;
	width: 100%;
	margin-top: ${typeScale(2)};

	${desktop`
		width: auto;
		margin-top: 0;
	`}
`;

export const CopyBtn = styled(Button)`
	display: flex;
	padding: 0 16px;
	line-height: 24px;
	height: 24px;
`;

export const ShareItem = styled.div`
	margin: 0 4px;
	display: flex;
	align-items: center;
`;

export const Icon = styled.div`
	margin-right: ${typeScale(1)};

	svg {
		display: block;
		margin: 0 auto;
		width: 16px;
		height: 24px;
	}
`;

export const Heading = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 64px;
`;

export const Header = styled.h3`
	color: ${getColor("gray")};
	font-size: 20px;
	line-height: 1.05;
	letter-spacing: 0.2px;
	margin: 0;
	padding: 0 ${typeScale(2)};
`;

export const DismissBtn = styled.button`
	${resetBtn};
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${getColor('dustyGray')};
	padding: 17px;
`;
